import modelBaseV2 from "../model-base-v2.model";

/**
 * User Channel Mapping Model
 * 
 * Contains all User Channel Mapping specific requests
 * 
 * @author cmcnkhiep(Ryan)
 */
const UserChannelMappingModel = {

	exportManageChannelByUser: (body, fileName) => {
		return modelBaseV2.post('/api/site/managed/relation/download', { body }, fileName);
	},

	exportUserChannelMapping: (file) => {
		const body = new FormData();
		body.append('file', file);

		return modelBaseV2.post('/api/site/managed/relation', { body });
	},

	downloadTemplateSiteManaged: () => {
		return modelBaseV2.getDownload('/api/site/managed/template/download', {}, 'UserChannelMappingTemplate.xlsx');
	},

}

export default UserChannelMappingModel;